export const hotLinks = [
  { id: 1, title: '2026年最新热门综艺合集·高清完整版在线观看', category: '综艺娱乐', url: 'https://example.com/1', views: '128.6万', tag: '热门', date: '2026-08-07' },
  { id: 2, title: '暑期档必看电影推荐·十部高分大片免费资源', category: '电影资源', url: 'https://example.com/2', views: '96.3万', tag: '推荐', date: '2026-08-06' },
  { id: 3, title: '经典国产电视剧全集·4K修复版重温童年记忆', category: '电视剧', url: 'https://example.com/3', views: '85.2万', tag: '经典', date: '2026-08-05' },
  { id: 4, title: '2026年春季新番动漫推荐·精选十部高分作品', category: '动漫动画', url: 'https://example.com/4', views: '73.8万', tag: '新番', date: '2026-08-07' },
  { id: 5, title: 'BBC自然纪录片系列·震撼视觉的动物世界之旅', category: '纪录片', url: 'https://example.com/5', views: '62.1万', tag: '高清', date: '2026-08-04' },
  { id: 6, title: 'NBA季后赛精彩回放·全程高清赛事集锦合集', category: '体育赛事', url: 'https://example.com/6', views: '91.5万', tag: '热门', date: '2026-08-06' },
  { id: 7, title: '2026年华语音乐MV精选·最新歌曲高清合集', category: '音乐MV', url: 'https://example.com/7', views: '55.4万', tag: '最新', date: '2026-08-07' },
  { id: 8, title: '名校公开课精选·哈佛耶鲁精品课程免费学习', category: '学习教育', url: 'https://example.com/8', views: '42.7万', tag: '精品', date: '2026-08-03' },
  { id: 9, title: '暑期档喜剧电影大赏·笑到停不下来的爆笑合集', category: '电影资源', url: 'https://example.com/9', views: '118.2万', tag: '爆款', date: '2026-08-07' },
  { id: 10, title: '热门综艺节目全集更新·每周最新精彩内容速递', category: '综艺娱乐', url: 'https://example.com/10', views: '77.9万', tag: '更新', date: '2026-08-06' },
  { id: 11, title: '国产高分剧推荐·豆瓣8.0以上必看神剧盘点', category: '电视剧', url: 'https://example.com/11', views: '69.3万', tag: '高分', date: '2026-08-05' },
  { id: 12, title: '热血动漫经典回顾·那些年我们追过的番剧合集', category: '动漫动画', url: 'https://example.com/12', views: '88.6万', tag: '经典', date: '2026-08-07' },
];

export const latestUpdates = [
  { id: 101, title: '《光影之旅》第三季完整版上线·探索世界顶级摄影师的视觉盛宴', category: '纪录片', date: '2026-08-07', tag: '新上线' },
  { id: 102, title: '暑期动画电影特辑·多部高分动画大片免费观看通道', category: '动漫动画', date: '2026-08-07', tag: '限时' },
  { id: 103, title: '经典港片修复版上线·高清画质重温黄金时代港产片', category: '电影资源', date: '2026-08-06', tag: '修复版' },
  { id: 104, title: '2026奥运精彩回放合集·中国队夺金时刻全记录', category: '体育赛事', date: '2026-08-06', tag: '热门' },
  { id: 105, title: '独立音乐人作品展·发现华语乐坛新声音精选集', category: '音乐MV', date: '2026-08-05', tag: '独家' },
  { id: 106, title: '编程入门到精通系列·零基础学编程全套视频教程', category: '学习教育', date: '2026-08-05', tag: '推荐' },
  { id: 107, title: '周末剧场·高分悬疑电影三部曲连播不容错过', category: '电影资源', date: '2026-08-04', tag: '连播' },
  { id: 108, title: '脱口秀大会全集更新·笑点密集全程高能不断', category: '综艺娱乐', date: '2026-08-04', tag: '更新' },
  { id: 109, title: '古装仙侠剧大盘点·近年最值得追的十部神作', category: '电视剧', date: '2026-08-03', tag: '盘点' },
  { id: 110, title: '日语入门速成·从五十音到流利对话完整教程', category: '学习教育', date: '2026-08-03', tag: '新人' },
  { id: 111, title: '欧洲杯赛事回顾·经典比赛全场高清录像合辑', category: '体育赛事', date: '2026-08-02', tag: '回顾' },
  { id: 112, title: '2026年热门偶像剧合集·甜蜜恋爱剧一网打尽', category: '电视剧', date: '2026-08-01', tag: '合集' },
];

export const stats = [
  { value: '12,680+', label: '收录网址' },
  { value: '8', label: '资源分类' },
  { value: '每日更新', label: '更新频率' },
  { value: '980万+', label: '累计访问' },
];

export const faqs = [
  { q: '这个网站需要注册才能使用吗？', a: '完全不需要注册！我们致力于提供最便捷的视频资源导航服务，所有链接均可直接访问，无需任何注册或登录步骤，打开即用。' },
  { q: '网站上的资源链接多久更新一次？', a: '我们每天都会对收录的福利视频网址进行检查和更新，确保所有链接的有效性。失效链接会被及时替换，同时不断添加新的优质资源。' },
  { q: '如何在手机端使用这个导航网站？', a: '我们的网站采用了响应式设计，完美适配手机、平板和电脑等各种设备。只需在手机浏览器中打开本网站，即可获得与电脑端同样流畅的浏览体验。' },
  { q: '收录的资源是否都是免费高清的？', a: '我们严格筛选收录的资源，优先推荐免费且支持高清播放的视频内容。每个收录的网址都经过人工审核，确保观看体验的流畅性和画质水准。' },
  { q: '如果发现链接失效了怎么办？', a: '如果您发现任何链接无法正常访问，欢迎通过关于我们页面的联系方式向我们反馈。我们的团队会在24小时内核实并进行修复更新。' },
];